<ng-content></ng-content>
<ng-container *ngIf="dwAutoGenerate">
  <dw-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs">
    <a [attr.href]="breadcrumb.url">{{ breadcrumb.label }}</a>
  </dw-breadcrumb-item>
</ng-container>
